import React, { useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import axios from 'axios'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { Link, useLocation } from 'react-router-dom'

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function GameImportRecords() {
    const [token, setToken] = useState("");
    const [days, setDays] = useState(1);
    const [gameSource, setGameSource] = useState("");
    const [status, setStatus] = useState("");
    const [appData, setAppData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [importing, setImporting] = useState(false);
    const apiPath = '/api/GameImportRecords?days=gameSource';

    const columns = [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                display: true,
                viewColumns: false,
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return (
                        <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                    )
                }
            }
        },
        {
            name: "importedOn",
            label: "Import Time",
            options: {
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "left" }}>{(new Date(value + "Z")).toLocaleString()}</div>
                )
            }
        },
        {
            name: "importedBy",
            label: "Imported By",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: true,
                viewColumns: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let record = appData[tableMeta.currentTableData[tableMeta.rowIndex].index];
                    return (
                        <div style={{ textAlign: "left" }}>
                            {record.gameOwnerUSCFId > 0 ? (<a href={'https://ratings.uschess.org/player/' + record.gameOwnerUSCFId} target='_blank' rel='noreferrer'>{value}</a>) :
                                (record.gameOwnerFIDEId > 0 ? (<a href={'https://ratings.fide.com/profile/' + record.gameOwnerFIDEId} target='_blank' rel='noreferrer'>{value}</a>) : value)}
                        </div>
                    );
                }
            }
        },
        {
            name: "gameSource",
            label: "Game Source",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                //customBodyRender: (value, tableMeta, updateValue) => {
                //    let record = appData[tableMeta.currentTableData[tableMeta.rowIndex].index];
                //    return (
                //        <div style={{ textAlign: "left" }}>
                //            <Button component={Link} target="_blank" to={'/EventGames/ByGameSource?gameSource=' + value} variant="contained" color="primary">
                //                {value}
                //            </Button>
                //        </div>
                //    );
                //}
            }
        },
        {
            name: "imported",
            label: "Imported",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "skipped",
            label: "Skipped",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "totalSecondsSpent",
            label: "Seconds",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true
            }
        },
        //{
        //    name: "originalFileName",
        //    label: "File Name",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            let record = appData[tableMeta.currentTableData[tableMeta.rowIndex].index];
        //            return (
        //                <div style={{ textAlign: "left" }}>
        //                    {record.downloadByUSCFId != -1 ? (<a href={'https://ratings.uschess.org/player/' + record.downloadByUSCFId} target='_blank' rel='noreferrer'>{value}</a>) :
        //                        (record.downloadByFIDEId != -1 ? (<a href={'https://ratings.fide.com/profile/' + record.downloadByFIDEId} target='_blank' rel='noreferrer'>{value}</a>) : value)}
        //                </div>
        //            );
        //        }
        //    }
        //},
        {
            name: "",
            label: "Action",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let record = appData[tableMeta.currentTableData[tableMeta.rowIndex].index];
                    return (
                        <div style={{ textAlign: "left" }}>
                            <Button component={Link} target="_blank" to={'/EventGames/ByGameSource?gameSource=' + record.gameSource} variant="contained" color="primary">
                                Edit
                            </Button>
                        </div>
                    );
                }
            }
        },
        {
            name: "downloadFromIP",
            label: "Download IP",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
    ];

    const options = {
        setTableProps: () => {
            return {
                size: 'small',
            };
        },
        filter: true,
        filterType: 'dropdown',
        responsive: 'standard',
        expandableRows: false,
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        download: false,
        print: false,
        rowsPerPage: 200,
        rowsPerPageOptions: [5, 10, 15, 25, 50, 100, 200],
        jumpToPage: true,
        fixedHeaderOptions: {
            xAxis: true,
            yAxis: true
        },
        resizableColumns: false,
        isRowExpandable: (dataIndex, expandedRows) => {
            // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
            if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                return false;
            return true;
        },
        rowsExpanded: [],
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    useEffect(async () => {
        setToken(await authService.getAccessToken());
    }, []); //Runs only on the first render

    const getAppData = async (e, playerName) => {
        e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }

        axios.get('/api/GameImportRecords?days=' + days + '&gameSource=' + gameSource, headers).then((response) => {
            setAppData(response.data);
            setLoading(false);
            setStatus("");
        }).catch((error) => {
            setLoading(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };

    const refreshChessComEvents = async (e) => {
        e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }

        axios.get('/api/ChesscomBroadcasts/PopulateChesscomEvents', headers).then((response) => {
            setStatus(response.data);
            setImporting(false);
        }).catch((error) => {
            setImporting(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };
    const importChessComEvents = async (e) => {
        e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }

        axios.get('/api/chessgames/AutoImportChesscomPGN', headers).then((response) => {
            setStatus(response.data);
            setImporting(false);
        }).catch((error) => {
            setImporting(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };
    const importLichess = async (e) => {
        e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }

        axios.get('/api/chessgames/AutoImportLichessPGN', headers).then((response) => {
            setStatus(response.data);
            setImporting(false);
        }).catch((error) => {
            setImporting(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };
    const importTWIC = async (e) => {
        e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }

        axios.get('/api/chessgames/AutoImportTWIC', headers).then((response) => {
            setStatus(response.data);
            setImporting(false);
        }).catch((error) => {
            setImporting(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };
    const importFIDE = async (e) => {
        e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }

        axios.get('/api/chessgames/AutoImportFIDEPGN', headers).then((response) => {
            setStatus(response.data);
            setImporting(false);
        }).catch((error) => {
            setImporting(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };

    return (
        <Box sx={{ pt: 2, pb: 2 }}>
            <Grid container direction="row" rowSpacing={1} columnSpacing={1} align-items="flex-end">
                <Grid item xs={12} lg={2}>
                    <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton color="success" fullWidth onClick={async (e) => { e.preventDefault(); setGameSource("FIDE"); await setImporting(true); await importFIDE(e); }} loading={importing} loadingIndicator="Importing..." variant="contained">Import FIDE</LoadingButton>
                    </Stack>
                </Grid>
                <Grid item xs={12} lg={2}>
                    <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton color="error" fullWidth onClick={async (e) => { e.preventDefault(); setGameSource("TWIC"); await setImporting(true); await importTWIC(e); }} loading={importing} loadingIndicator="Importing..." variant="contained">Import TWIC</LoadingButton>
                    </Stack>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton color="secondary" fullWidth onClick={async (e) => { e.preventDefault(); setGameSource("Lichess"); await setImporting(true); await importLichess(e); }} loading={importing} loadingIndicator="Importing..." variant="contained">Import Lichess</LoadingButton>
                    </Stack>
                </Grid>
                <Grid item xs={12} lg={2}>
                    <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton color="info" fullWidth onClick={async (e) => { e.preventDefault(); setGameSource("Chesscom"); await setImporting(true); await importChessComEvents(e); }} loading={importing} loadingIndicator="Importing..." variant="contained">Chesss.Com</LoadingButton>
                    </Stack>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton color="warning" fullWidth onClick={async (e) => { e.preventDefault(); setGameSource("Chesscom"); await setImporting(true); await refreshChessComEvents(e); }} loading={importing} loadingIndicator="Freshing..." variant="contained">Fresh Chess.Com</LoadingButton>
                    </Stack>
                </Grid>
                <Grid item xs={12} lg={2} >
                    <TextField
                        size="small"
                        fullWidth
                        id="outlined-number"
                        label={"Imports In The Past " + days + " Day(s)"}
                        type="number"
                        inputProps={{ min: 1, max: 365 }}
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={days}
                        onChange={(e) => setDays(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={5} >
                    <TextField
                        size="small"
                        fullWidth
                        id="outlined-number"
                        label={"Game Source Name"}
                        inputProps={{ min: 1, max: 365 }}
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={gameSource}
                        onChange={(e) => setGameSource(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} lg={5}>
                    <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton fullWidth onClick={async (e) => { e.preventDefault(); await setLoading(true); await getAppData(e, days, gameSource); }} loading={loading} loadingIndicator="Loading..." variant="contained">Show Imports of Past {days} Day(s)</LoadingButton>
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <div>
                        <label>{status}</label>
                    </div>
                </Grid>
                {appData.length > 0 &&
                    <Grid item xs={12}>
                        <CacheProvider value={muiCache}>
                            <ThemeProvider theme={theme}>
                                <MUIDataTable
                                    /*title={appData.length + " import(s) in the past " + days + " day(s)"}*/
                                    title={
                                        <div>
                                            <Button variant="contained" color="secondary"
                                                onClick={async (e) => { e.preventDefault(); await setAppData([]); /*await setSelectedUser(); await setSearchString("")*/ }}>
                                                {"Clear Results (" + appData.length + ")"}
                                            </Button>
                                        </div>
                                    }
                                    data={appData}
                                    columns={columns}
                                    options={options}
                                    components={components}
                                />

                            </ThemeProvider>
                        </CacheProvider>
                    </Grid>
                }
            </Grid>

        </Box>
    )
}

